import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, Lock, CreditCard, ChevronDown, Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OrderBump } from './OrderBump';
export function Pricing() {
  const [bonusesOpen, setBonusesOpen] = useState(false);
  const [bumpAdded, setBumpAdded] = useState(false);
  const bonuses = [{
    title: '30 Ganchos (Hooks) Virales',
    desc: 'Frases exactas para detener el scroll y atraer prospectos en Reels e Historias.',
    value: '$19 USD'
  }, {
    title: 'Plantillas de Canva para Post de Reclutamiento',
    desc: '10 diseños listos para publicar (Reels, Carruseles y Stories) sin perder horas diseñando.',
    value: '$27 USD'
  }, {
    title: 'Guía Anti-Objeciones (El Escudo del Networker)',
    desc: 'Qué responder exactamente cuando te dicen: "¿Es pirámide?" o "No tengo dinero".',
    value: '$25 USD'
  }];
  const total = bumpAdded ? 24 : 17;
  return <section id="pricing-section" className="bg-brand-dark px-6 py-20 md:py-28 relative overflow-hidden" data-id="element-115">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-gold/10 blur-[120px] rounded-full pointer-events-none" data-id="element-116"></div>

      <div className="mx-auto max-w-4xl relative z-10" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-darker border-2 border-brand-gold rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(212,168,67,0.15)]" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-119">
            Obtén el Sistema Completo Hoy
          </h2>

          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto" data-id="element-120">
            Hoy puedes obtener el sistema completo de Networker Magnético y
            todos los bonos por una fracción de lo que gastas en una cena o en
            muestras de producto.
          </p>

          {/* Collapsible Bonuses Summary */}
          <div className="w-full max-w-lg mx-auto mb-8" data-id="element-121">
            <button onClick={() => setBonusesOpen(!bonusesOpen)} className="w-full flex items-center justify-between bg-brand-light border border-slate-700 rounded-xl px-6 py-4 text-left transition-colors hover:border-brand-gold/40 focus:outline-none" data-id="element-122">
              <div className="flex items-center gap-3" data-id="element-123">
                <Gift className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-124" />
                <span className="text-white font-semibold" data-id="element-125">
                  Ver los 3 Bonos Incluidos{' '}
                  <span className="text-green-400 text-sm font-bold ml-1" data-id="element-126">
                    GRATIS
                  </span>
                </span>
              </div>
              <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${bonusesOpen ? 'rotate-180' : ''}`} data-id="element-127" />
            </button>

            <AnimatePresence data-id="element-128">
              {bonusesOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-129">
                  <div className="bg-brand-light border border-t-0 border-slate-700 rounded-b-xl px-6 pb-5 pt-2 space-y-4" data-id="element-130">
                    {bonuses.map((bonus, i) => <div key={i} className="flex items-start gap-4 text-left border-b border-slate-800 last:border-b-0 pb-4 last:pb-0" data-id="element-131">
                        <span className="flex-shrink-0 mt-1 w-7 h-7 rounded-full bg-brand-gold/10 border border-brand-gold/30 flex items-center justify-center text-brand-gold text-xs font-bold" data-id="element-132">
                          {i + 1}
                        </span>
                        <div className="flex-1 min-w-0" data-id="element-133">
                          <p className="text-white font-semibold text-sm" data-id="element-134">
                            {bonus.title}
                          </p>
                          <p className="text-slate-400 text-xs mt-1" data-id="element-135">
                            {bonus.desc}
                          </p>
                        </div>
                        <span className="flex-shrink-0 text-slate-500 line-through text-sm mt-0.5" data-id="element-136">
                          {bonus.value}
                        </span>
                      </div>)}
                    <div className="pt-2 text-center" data-id="element-137">
                      <span className="text-xs text-slate-500" data-id="element-138">
                        Valor total de bonos:{' '}
                        <span className="line-through" data-id="element-139">$71 USD</span>
                      </span>
                      <span className="text-green-400 font-bold text-xs ml-2" data-id="element-140">
                        → INCLUIDOS GRATIS
                      </span>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          {/* Price block */}
          <div className="bg-brand-light rounded-2xl p-8 mb-6 border border-slate-800 inline-block w-full max-w-md mx-auto" data-id="element-141">
            <div className="text-slate-400 font-medium mb-2 uppercase tracking-wide text-sm" data-id="element-142">
              Precio Especial de Lanzamiento
            </div>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-143">
              <span className="text-2xl text-slate-500 line-through decoration-red-500/50" data-id="element-144">
                $67 USD
              </span>
              <motion.span key={total} initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} className="text-6xl font-extrabold text-brand-gold" data-id="element-145">
                ${total} <span className="text-2xl" data-id="element-146">USD</span>
              </motion.span>
            </div>
            <div className="inline-block bg-red-500/10 text-red-400 text-sm font-bold px-3 py-1 rounded-full mt-2 border border-red-500/20" data-id="element-147">
              Oferta por tiempo limitado
            </div>
          </div>

          {/* CTA below price */}
          <div className="flex flex-col items-center gap-3 mb-8" data-id="element-148">
            <CTAButton text={`¡QUIERO TODO POR SOLO ${total} USD!`} href={bumpAdded ? 'https://prospectflow.store/cart/47665871061250:1' : 'https://prospectflow.store/cart/47665212293378:1'} className="w-full md:w-auto text-lg py-5 px-8" data-id="element-149" />
            <p className="text-slate-500 text-xs" data-id="element-150">Acceso inmediato y seguro</p>
          </div>

          {/* Order Bump — above summary */}
          <div className="mb-6" data-id="element-151">
            <OrderBump checked={bumpAdded} onChange={setBumpAdded} data-id="element-152" />
          </div>

          {/* Price Summary */}
          <div className="w-full max-w-md mx-auto mb-8" data-id="element-153">
            <div className="bg-brand-light rounded-xl border border-slate-700 p-5 text-left space-y-3" data-id="element-154">
              <h4 className="text-white font-bold text-sm uppercase tracking-wide text-center mb-4" data-id="element-155">
                Resumen de tu orden
              </h4>

              <div className="flex justify-between items-center text-sm" data-id="element-156">
                <span className="text-slate-300" data-id="element-157">
                  Networker Magnético (Plan 7 Días)
                </span>
                <div className="flex items-center gap-2" data-id="element-158">
                  <span className="text-slate-500 line-through text-xs" data-id="element-159">
                    $67
                  </span>
                  <span className="text-white font-bold" data-id="element-160">$17</span>
                </div>
              </div>

              <div className="flex justify-between items-center text-sm" data-id="element-161">
                <span className="text-slate-300" data-id="element-162">3 Bonos Incluidos</span>
                <div className="flex items-center gap-2" data-id="element-163">
                  <span className="text-slate-500 line-through text-xs" data-id="element-164">
                    $71
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-165">GRATIS</span>
                </div>
              </div>

              <AnimatePresence data-id="element-166">
                {bumpAdded && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} className="overflow-hidden" data-id="element-167">
                    <div className="flex justify-between items-center text-sm" data-id="element-168">
                      <span className="text-slate-300" data-id="element-169">
                        21 Guiones Magnéticos
                      </span>
                      <div className="flex items-center gap-2" data-id="element-170">
                        <span className="text-slate-500 line-through text-xs" data-id="element-171">
                          $21
                        </span>
                        <span className="text-white font-bold" data-id="element-172">$7</span>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>

              <div className="border-t border-slate-700 pt-3 mt-3 flex justify-between items-center" data-id="element-173">
                <span className="text-white font-bold text-base" data-id="element-174">
                  Total hoy:
                </span>
                <motion.span key={total} initial={{
                scale: 1.15
              }} animate={{
                scale: 1
              }} className="text-brand-gold font-extrabold text-2xl" data-id="element-175">
                  ${total} USD
                </motion.span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col items-center gap-4" data-id="element-176">
            <CTAButton text={`¡QUIERO TODO POR SOLO ${total} USD!`} href={bumpAdded ? 'https://prospectflow.store/cart/47665871061250:1' : 'https://prospectflow.store/cart/47665212293378:1'} className="w-full md:w-auto text-xl py-6 px-10" data-id="element-177" />
            <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400 font-medium" data-id="element-178">
              <div className="flex items-center gap-2" data-id="element-179">
                <Shield className="w-5 h-5 text-green-500" data-id="element-180" />
                30 días de garantía total
              </div>
              <div className="flex items-center gap-2" data-id="element-181">
                <Lock className="w-5 h-5 text-slate-300" data-id="element-182" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-183">
                <CreditCard className="w-5 h-5 text-slate-300" data-id="element-184" />
                Acceso Inmediato
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}